import compiler from "mson/lib/compiler";
import moment from "moment";
import ReactDOM from "react-dom";
import globals from "mson/lib/globals";
import "react-notifications/lib/notifications.css";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";

import { loadLatestFromBase } from "./scanAndSearch";
import { strings } from "./strings";
import TextField from "./textField";

import sha256 from "./sha256";

// eslint-disable-next-line
import {
  AuthStatus,
  // eslint-disable-next-line
  AuthStatusField,
  // eslint-disable-next-line
  CurrentFormField,
  CurrentForm,
} from "../components/mson";

// eslint-disable-next-line
import SearchFieldsField from "../components/mson/SearchFields";
import SearchFieldsFieldUI from "../components/mson/SearchFieldsUI";

// eslint-disable-next-line
import FormNavigationField from "../components/mson/FormNavigation";
import FormNavigationFieldUI from "../components/mson/FormNavigationUI";

import MSONUIComponents from "mson-react/lib/components";

MSONUIComponents.AuthStatus = AuthStatus;
MSONUIComponents.CurrentForm = CurrentForm;
MSONUIComponents.SearchFieldsField = SearchFieldsFieldUI;
MSONUIComponents.FormNavigationField = FormNavigationFieldUI;

const form = compiler.newComponent({
  component: "Form",
  name: "app.AgentForm",
  fields: [
    {
      name: "Auth",
      component: "AuthStatus",
    },
    {
      name: "CurrentForm",
      component: "CurrentForm",
    },
    {
      name: "DescriptionField",
      text: strings.descriptionLabel,
      component: "Text",
    },
    TextField("\n***\n"),
    {
      name: "FormNav",
      value: "foo",
      component: "FormNavigationField",
    },
    {
      name: "SearchFields",
      value: "foo",
      component: "SearchFieldsField",
    },
  ],
});

const lookupAndRedirect = (formContext) => async (baseLookup) => {
  const currentForm = await loadLatestFromBase(baseLookup);
  if (currentForm) {
    formContext.setForm(currentForm);
    globals.redirect("/mark");
    // reset the search form

    form.reset();
  } else {
    NotificationManager.error(
      "Unable to find traveller, please check your terms and try again",
      "",
      10000
    );
  }
};
form["submit"] = async () => {
  const roleValue = localStorage.getItem("location-select");
  if (!roleValue || roleValue === null || roleValue === "null") {
    NotificationManager.error(
      "Enter agent location prior to searching",
      "",
      10000
    );
    return false;
  } else {
    const formValues = form.getValues();
    const formContext = formValues.CurrentForm;
    const DateValue = document.getElementById("date-picker-dialog").value;
    const dobDD = document.getElementById("dd-select").value;
    const dobMM = document.getElementById("mm-select").value;
    const dobYYYY = document.getElementById("yyyy-select").value;
    const passportValue = document.getElementById("passport-number").value;
    const country = document.getElementById("country-select").value;
    const countryValue = strings.countries.find((x) => x.label === country)
      .value;

    const dateVal = moment
      .utc(DateValue)
      .tz("Pacific/Guam")
      .startOf("day")
      .toISOString();
    const baseString = `${dateVal};${dobDD}-${dobMM}-${dobYYYY};-${passportValue};${countryValue}`;
    const baseLookup = sha256(baseString);
    await lookupAndRedirect(formContext)(baseLookup);
  }
};
form.on("load", () => {
  document.getElementById("buttonHolder").style.visibility = "visible";
  const notifier = <NotificationContainer />;
  ReactDOM.render(notifier, document.getElementById("app"));
});
// date of flight, date of birth, passport number and passport country
export default form;
